












































import Component from 'vue-class-component'
import Inventory from '@/modules/inventory/domain/inventory'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class InventoryMovementsSummaryBox extends Vue {
  @Prop({ type: Inventory, required: true }) inventory!: Inventory
}
